import React from 'react'

class ClaimSectionBreadcrumb extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (
      <div className='section-name-div'>
        { this.props.index > 0 && <div className='separator' /> }
        <div className={`section-group-status ${this.props.completedClass} ${this.props.activeClass}`} >
          <div className='round' />
        </div>
        <div className='section-name'>{this.props.sectionGroupName}</div>
      </div>
    )
  }
}

export default ClaimSectionBreadcrumb;
